import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=5f025608&scoped=true&"
import script from "./UserListTable.vue?vue&type=script&lang=ts&"
export * from "./UserListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f025608",
  null
  
)

export default component.exports